import { instance } from 'api/axios.instance';

export function toDateInput(value) {
  if (!value) return '';
  return String(value).slice(0, 10);
}

export function isFormUsed(form) {
  if (typeof form?.isUsed === 'boolean') return form.isUsed;
  return String(form?.useYn || '').toUpperCase() === 'Y';
}

function resolveThumbnail(url) {
  if (!url) return '';
  if (String(url).startsWith('http')) return url;
  return `${process.env.REACT_APP_API_BASE || ''}${url}`;
}

function selectIssuesForForm(issues, formId) {
  const hasField = issues.some(issue => Object.prototype.hasOwnProperty.call(issue, 'linkedFormId'));
  if (!hasField) return issues;
  return issues.filter(issue => String(issue.linkedFormId) === String(formId));
}

export async function fetchVoteForms() {
  const response = await instance('/form/templates', {
    method: 'GET',
    params: { forVote: true }
  });
  return response.data?.data || [];
}

export async function fetchIssuesByForm(formId, currentUserId) {
  const issues = [];
  let pageNo = 1;
  let totalPage = 1;

  do {
    const response = await instance('/local-issue/list', {
      method: 'POST',
      data: {
        pageNo,
        searchType: '',
        search: '',
        region: '',
        linkedFormId: formId
      }
    });
    const data = response.data?.data || {};
    issues.push(...(data.issues || []));
    totalPage = Number(data.pagination?.totalPage) || 1;
    pageNo += 1;
  } while (pageNo <= totalPage && pageNo <= 50);

  return selectIssuesForForm(issues, formId).map(issue => ({
    id: issue.id,
    title: issue.title,
    thumbnail: resolveThumbnail(issue.thumbnailUrl || issue.thumbnail),
    thumbsUpCount: issue.thumbsUpCount || 0,
    isLiked: Array.isArray(issue.userList) ? issue.userList.includes(currentUserId) : Boolean(issue.isLiked)
  }));
}

export async function toggleIssueLike(issueId, isLiked) {
  const action = isLiked ? 'off' : 'on';
  return instance(`/local-issue/like/${issueId}/${action}`, {
    method: 'GET',
    validateStatus: status => status < 500
  });
}
